import React from 'react'

// material ui
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const CartProduct = ({ description, total }) => {
  return (
    <Box my={1} display='flex'>
      <Box display='flex' flexGrow={1}>
        <Typography>{description}</Typography>
      </Box>
      <Box display='flex'>
        <Typography>{total}</Typography>
      </Box>
    </Box>
  )
}

export default CartProduct
